const principles = [
  {
    title: 'Clean Architecture',
    description: 'Structured, modular codebases designed for clarity and adaptability.',
  },
  {
    title: 'Performance Optimization',
    description: 'Systems engineered for speed, efficiency, and resource consciousness.',
  },
  {
    title: 'User-Centered Design',
    description: 'Interfaces shaped by thoughtful consideration of human interaction.',
  },
];

export default function PrinciplesSection() {
  return (
    <section
      className="w-full bg-background-100 py-28 px-6 md:px-10 lg:px-16"
      aria-label="Engineering principles"
    >
      <div className="max-w-[1200px] mx-auto">
        <h2 className="font-heading text-[2.2rem] md:text-[2.6rem] font-semibold text-foreground-950 text-center mb-20 tracking-tight">
          Engineering Principles
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {principles.map((principle) => (
            <div
              key={principle.title}
              className="bg-background-50 border border-accent-200 rounded-2xl p-10 md:p-12 flex flex-col items-center justify-center text-center aspect-[1/1] transition-colors duration-300"
            >
              <h3 className="font-body text-xl md:text-[1.35rem] font-semibold text-foreground-900 mb-3">
                {principle.title}
              </h3>
              <p className="font-body text-[0.95rem] text-foreground-500 leading-relaxed max-w-[16rem]">
                {principle.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}